module.exports = __webpack_public_path__ + "static/img/039_TO8_1532_og.2b7c1dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/039_TO8_1532_og.jpg
// module id = AaqD
// module chunks = 0